import React, { Component } from 'react'; // eslint-disable-line no-unused-vars

// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/eventemitter3` if it exist... Remove this comment to see the full error message
import EventEmitter from 'eventemitter3';

// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/fbjs` if it exists or add ... Remove this comment to see the full error message
import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import { getDefaultViewport } from '../core/util/device/screen';

let EE: any;
let viewport = getDefaultViewport();
const RESIZE_EVENT = 'resize';

function handleWindowResize() {
  if (viewport.width !== window.innerWidth || viewport.height !== window.innerHeight) {
    viewport = { width: window.innerWidth, height: window.innerHeight };
    EE.emit(RESIZE_EVENT, viewport);
  }
}

function withViewport<Props>(ComposedComponent: React.ComponentType<Props>) {
  return class WithViewport extends Component<Props> {
    constructor() {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
      super();

      this.state = {
        viewport: canUseDOM ? { width: window.innerWidth, height: window.innerHeight } : viewport,
      };
    }

    componentDidMount() {
      if (!EE) {
        EE = new EventEmitter();
        window.addEventListener('resize', handleWindowResize);
        window.addEventListener('orientationchange', handleWindowResize);
      }

      EE.on(RESIZE_EVENT, this.handleResize, this);
    }

    componentWillUnmount() {
      if (!EE) return;
      EE.removeListener(RESIZE_EVENT, this.handleResize, this);
      if (!EE.listeners(RESIZE_EVENT, true)) {
        window.removeEventListener('resize', handleWindowResize);
        window.removeEventListener('orientationchange', handleWindowResize);
        EE = null;
      }
    }

    handleResize(value: any) {
      this.setState({ viewport: value }); // eslint-disable-line react/no-set-state
    }

    render() {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'viewport' does not exist on type 'Readon... Remove this comment to see the full error message
      return <ComposedComponent {...this.props} viewport={this.state.viewport} />;
    }
  };
}

export default withViewport;
